import React from 'react';
import T from 'prop-types';
import { Input, Form } from 'antd';

import { MODAL_LOGIN } from '../../../../constants/app';

import AuthFormLinks from '../../../authFormLinks';
import ErrorAlert from '../../../errorAlert';
import Modal from '../../../modal';
import FormItem from '../../../formItem';

import { config } from './config';
import * as params from '../../../../constants/params';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

const LoginModal = ({ error, errorMessage, isLoading, login, redirectTo, reset, updateQueryString }) => {
  const handleOFinish = (v) => {
    const obj = { redirectTo, ...v };
    login(obj);
  };

  const handleOnCancel = () => {
    reset();
    updateQueryString({
      [params.REDIRECT_TO]: undefined,
    });
  };

  return (
    <Modal
      name={MODAL_LOGIN}
      okButtonProps={{ htmlType: 'submit', form: MODAL_LOGIN, 'data-cy': 'login-btn-submit', loading: isLoading }}
      okText="Log In"
      onCancel={handleOnCancel}
      title="Log In"
    >
      <ErrorAlert message={errorMessage} visible={error} />

      <Form name={MODAL_LOGIN} onFinish={handleOFinish} {...formItemLayout}>
        <FormItem label="E-mail" name="email" {...config.email}>
          <Input data-cy="login-form-email" />
        </FormItem>
        <FormItem label="Password" name="password" {...config.password}>
          <Input.Password data-cy="login-form-password" />
        </FormItem>
      </Form>
      <AuthFormLinks password resendConfirmation signup />
    </Modal>
  );
};

LoginModal.propTypes = {
  login: T.func.isRequired,
  reset: T.func.isRequired,
  updateQueryString: T.func.isRequired,

  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  isLoading: T.bool.isRequired,
  redirectTo: T.string.isRequired,
};

export default LoginModal;
